import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from '../shared/services';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardGuard implements CanActivate, CanActivateChild {

  constructor(private router: Router, public localStorage: StorageService){ }

  private checkAccess(stateUrl: string): boolean | UrlTree {
    if (!this.localStorage.isAuthenticated()) {
      console.log("not user auth ****");
      return this.router.parseUrl('/auth');
    }
    const roles = this.localStorage.user?.roles_list?.map((role) => role.name) || [];
    const isSuperAdmin = roles.includes('super_admin');

    const cleanUrl = stateUrl.startsWith('/') ? stateUrl.slice(1) : stateUrl;
    console.log({CLEAN_URL : cleanUrl});
    console.log({IS_SUPER_ADMIN : isSuperAdmin});

    if (isSuperAdmin && cleanUrl.startsWith('tabs')) {
      return this.router.parseUrl('/super-admin/dashboard');
    }

    if (!isSuperAdmin && cleanUrl.startsWith('super-admin')) {
      return this.router.parseUrl('/tabs/prayer-for-all');
    }

    return true;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.checkAccess(state.url);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.checkAccess(state.url);
  }
}